module["exports"] = [
  "vit",
  "silver",
  "grå",
  "svart",
  "röd",
  "grön",
  "blå",
  "gul",
  "lila",
  "indigo",
  "guld",
  "brun",
  "rosa",
  "purpur",
  "korall"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/commerce/color.js
 ** module id = 1008
 ** module chunks = 0
 **/